import { addEmailStatus } from './email';
import { supabase } from './supabase';

export const sendTestEmail = async (recipientEmail: string): Promise<boolean> => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token ?? import.meta.env.VITE_SUPABASE_ANON_KEY;

    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-email`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        },
        body: JSON.stringify({
          emailType: 'test',
          to: recipientEmail,
        }),
      }
    );

    const result = await response.json();

    addEmailStatus({
      success: result.success,
      message: result.message,
      timestamp: new Date(),
      recipient: recipientEmail,
      subject: result.subject,
    });

    return result.success;
  } catch (error: any) {
    addEmailStatus({
      success: false,
      message: `Error: ${error.message || 'Failed to send test email'}`,
      timestamp: new Date(),
      recipient: recipientEmail,
      error,
    });

    return false;
  }
};

export const testEmailConnection = async (): Promise<{ success: boolean; message: string; provider?: string }> => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token ?? import.meta.env.VITE_SUPABASE_ANON_KEY;

    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-email`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        },
        body: JSON.stringify({ action: 'test_connection' }),
      }
    );

    return await response.json();
  } catch (error: any) {
    return {
      success: false,
      message: error.message || 'Failed to test connection',
    };
  }
};
